import { combineReducers } from "redux";
import authenticationReducer from "./Authentication/reducer";
import siteReducer from "./Site/reducer";
import workerReducer from "./Worker/reducer";
import missionReducer from "./Mission/reducer";
import * as workerActions from "./Worker/actionTypes";
import * as missionActions from "./Mission/actionTypes";
import * as siteActions from "./Site/actionTypes";
import { sortWorkersByDate, sortMissionsByDate } from "../utils/Sort";

const appReducer = combineReducers({
  authentication: authenticationReducer,
  site: siteReducer,
  worker: workerReducer,
  mission: missionReducer
});

function crossSliceReducer(state, action) {
  switch (action.type) {
    case workerActions.GET_WORKERS: {


      // get workers for a site
      const site = state.site.sites.find(e => e.id === action.payload.site.id);
      if (site && state.worker) {
        // site found is array
        state.worker.workers = site.workers ? site.workers : [];
      }

      if (state.worker) {
        state.worker.workers = sortWorkersByDate(state.worker.workers)
      }

      return {
        ...state,
        worker: state.worker
      };
    }

    case workerActions.GET_WORKERS_SUCCESS: {


      // find index
      const index = state.site.sites.findIndex(
        e => e.id === action.meta.site.id
      );

      if (index >= 0) {
        // find site and add worker to this site
        const site = state.site.sites[index];

        // set workers in site
        site.workers = action.payload;

        // replace site in array
        state.site.site = site;
        state.site.sites[index] = site;

        return {
          ...state,
          site: state.site
        };
      } else {
        return {
          ...state
        };
      }
    }

    case workerActions.CREATE_WORKER: {


      // get created worker in state
      if (!state.worker) {
        return state;
      }
      const worker = state.worker.worker;


      if (worker && worker.site) {
        // find site index
        const index = state.site.sites.findIndex(e => e.id === worker.site.id);

        if (index >= 0) {
          // find site and add worker to this site
          const site = state.site.sites[index];

          // Initialize workers array if it doesn't exist
          if (!site.workers) {
            site.workers = [];
          }

          site.workers.push(worker);

          // sort workers
          site.workers = sortWorkersByDate(site.workers);

          state.site.site = site;
          state.site.sites[index] = site;

          return {
            ...state,
            site: state.site
          };
        }
      }

      return state;
    }

    case workerActions.CREATE_WORKER_SUCCESS: {
      if (!state.worker || !action.payload) {
        return state;
      }

      const createdWorker = action.payload;
      const siteId = createdWorker.site?.id ?? action.meta?.site?.id;
      if (!siteId) {
        return state;
      }

      const index = state.site.sites.findIndex(e => e.id === siteId);
      if (index < 0) {
        return state;
      }

      const site = state.site.sites[index];
      if (!site.workers) {
        site.workers = [];
      }

      // Replace optimistic temp worker (localId) with the persisted one
      site.workers = site.workers.filter(
        w => w.id !== action.meta.localId && w.id !== createdWorker.id
      );
      site.workers.push(createdWorker);
      site.workers = sortWorkersByDate(site.workers);

      state.site.site = site;
      state.site.sites[index] = site;

      return {
        ...state,
        site: state.site
      };
    }

    case workerActions.CREATE_WORKER_FAILURE: {
      const localId = action.meta?.localId;
      if (!localId || !state.site?.sites) {
        return state;
      }

      const sites = state.site.sites.map(site => {
        if (!site.workers) {
          return site;
        }
        return {
          ...site,
          workers: site.workers.filter(w => w.id !== localId)
        };
      });

      const currentSite =
        state.site.site && state.site.site.workers
          ? {
              ...state.site.site,
              workers: state.site.site.workers.filter(w => w.id !== localId)
            }
          : state.site.site;

      return {
        ...state,
        site: {
          ...state.site,
          sites,
          site: currentSite
        }
      };
    }

    case workerActions.UPDATE_WORKER: {


      // get updated worker in state
      if (!state.worker) {
        return state;
      }
      const worker = state.worker.worker;


      if (worker && worker.site) {
        // find site index
        const index = state.site.sites.findIndex(e => e.id === worker.site.id);

        if (index >= 0) {
          // find site and get worker using id
          const site = state.site.sites[index];

          // Initialize workers array if it doesn't exist
          if (!site.workers) {
            site.workers = [];
          }

          // get worker index and replace it
          const i = site.workers.findIndex(e => e.id === worker.id);

          if (i >= 0) {
            site.workers[i] = worker;
          } else {
            site.workers.push(worker);
          }

          // sort workers
          site.workers = sortWorkersByDate(site.workers);

          // replace
          state.site.site = site;
          state.site.sites[index] = site;

          return {
            ...state,
            site: state.site
          };
        }
      } else {
        return {
          ...state
        };
      }
    }

    case workerActions.UPDATE_WORKER_FAILURE: {

      return {
        ...state
      };
    }

    case missionActions.CREATE_MISSION: {

      // get created mission
      const mission = state.mission.mission;

      if (!mission || !mission.site) {
        return state;
      }

      // find site - check sites array first, then state.site.site (when viewing single site)
      const index = state.site.sites.findIndex(e => e.id === mission.site.id);
      let site = index >= 0 ? state.site.sites[index] : null;
      if (!site && state.site.site && state.site.site.id === mission.site.id) {
        site = state.site.site;
      }

      if (!site) {
        return state;
      }

      // delete object from mission
      delete (mission as any).site;

      // set author
      mission.author = state.authentication.user;

      // add mission to site
      if (!site.missions) {
        site.missions = [];
      }
      site.missions.push(mission);
      site.missions = sortMissionsByDate(site.missions);

      state.site.site = site;
      if (index >= 0) {
        state.site.sites[index] = site;
      }

      return {
        ...state,
        site: state.site
      };
    }

    case missionActions.CREATE_MISSION_FAILURE: {


      return {
        ...state
      };
    }

    case missionActions.UPDATE_MISSION: {

      // get updated mission
      const mission = state.mission.mission;

      if (!mission || !mission.site) {
        return state;
      }

      // find site - check sites array first, then state.site.site (when viewing single site)
      const index = state.site.sites.findIndex(e => e.id === mission.site.id);
      let site = index >= 0 ? state.site.sites[index] : null;
      if (!site && state.site.site && state.site.site.id === mission.site.id) {
        site = state.site.site;
      }

      if (!site || !site.missions) {
        return state;
      }

      // get mission index and replace it
      const i = site.missions.findIndex(e => e.id === mission.id);
      if (i >= 0) {
        site.missions[i] = {
          ...site.missions[i],
          temp: mission.temp,
          updated_at: mission.updated_at,
          comment: mission.comment
        };

        state.site.site = site;
        if (index >= 0) {
          state.site.sites[index] = site;
        }

        return {
          ...state,
          site: state.site
        };
      }

      return state;
    }

    case missionActions.UPDATE_MISSION_FAILURE: {

      return {
        ...state
      };
    }

    case workerActions.UPDATE_CONTROL: {


      // find site index
      const index = state.site.sites.findIndex(
        e => e.id === action.payload.site.id
      );



      if (index >= 0) {
        // find site and get worker
        const site = state.site.sites[index];

        // Initialize workers array if it doesn't exist
        if (!site.workers) {
          site.workers = [];
        }

        // get worker index
        const i = site.workers.findIndex(
          e => e.id === action.payload.worker.id
        );



        if (i >= 0) {
          // worker found
          const worker = site.workers[i];

          // find worker controles
          const j = worker.controles?.findIndex(c => c.id === action.payload.id);



          if (j >= 0) {
            site.workers[i].controles[j].comment = action.payload.comment;
            site.workers[i].controles[j].validated = action.payload.validated;


          }

          // replace
          state.site.site = site;
          state.site.sites[index] = site;
        }

        return {
          ...state,
          site: state.site
        };
      } else {
        return {
          ...state
        };
      }
    }

    case workerActions.UPDATE_CONTROL_FAILURE: {

      return {
        ...state
      };
    }

    case siteActions.GET_SITE: {

      return {
        ...state
      };
    }

    case siteActions.GET_SITE_FAILURE: {

      return {
        ...state
      };
    }

    default:
      return state;
  }
}

const rootReducer = (state, action) => {
  const intermediateState = appReducer(state, action);
  const finalState = crossSliceReducer(intermediateState, action);
  return finalState;
};

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
